import { useSubmitStagesMutation } from '@/api/setters';
import { Stages } from '@/api/types';
import WarningIcon from '@/assets/warning.svg?react';
import ChatMessage from '@/components/ChatMessage';
import Button, {
  ButtonLoading,
  ButtonRightArrow,
} from '@/components/ui/Button';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const StepPaymentFailed = () => {
  const { i18n } = useLingui();
  const submitStages = useSubmitStagesMutation();

  return (
    <>
      <ChatMessage
        variant="primary"
        className="pb-0"
        consultant={CONSULTANTS.KASIA_ASSISTANT}
        description={i18n.t('Coś poszło nie tak podczas płatności.')}
        hideCloseButton
      />

      <div className="flex flex-col gap-3 rounded-xlg bg-white p-[14px] md:gap-5 md:p-6">
        <div className="flex items-center gap-3">
          <WarningIcon className="size-8 shrink-0 text-red-400" />
          <p className="h3 text-red-400">
            {i18n.t('Płatność nie powiodła się')}
          </p>
        </div>

        <p className="caption-large text-dark-gray-500">
          {i18n.t(
            'Nie udało się dokończyć płatności. Spróbuj ponownie — nic nie zostało jeszcze pobrane.'
          )}
        </p>

        <Button
          onClick={() => submitStages.mutateAsync(Stages.STAGE_ORDER)}
          loading={submitStages.isPending}
          className="ml-auto"
        >
          {i18n.t('Spróbuj ponownie')}
          <ButtonRightArrow />
          <ButtonLoading />
        </Button>
      </div>
    </>
  );
};

export default StepPaymentFailed;
